import { client } from "./api";
import {
  IPolicemanServiceProps,
  IPoliceman,
  IUpdatePolicemen,
  IGetByIdPoliceman,
  IPolicemanUpdateServiceProps,
  IPolicemenValues,
} from "interfaces/Policeman";

import axios, { AxiosResponse } from "axios";

import {
  IFilterData,
  IFilterWithoutPageData,
  IGetFilterProps,
  IGetUniqueData,
  IUseParams,
} from "interfaces/FilterProps";
import { useQuery } from "react-query";

type IGetPolicemanResponse = {
  data: IGetByIdPoliceman;
  status: boolean;
};

type IGetUpdatePolicemenResponse = {
  data: IUpdatePolicemen[];
  status: boolean;
};

type IGetPolicemanMap = {
  policeman: IGetPolicemanResponse;
  workStatus: any;
};

export async function getPolicemenService({
  order,
  relations,
  skip,
  take,
  where,
}: IGetFilterProps<IPoliceman>): Promise<FilteredPolicemanResponse> {
  const api = client();
  const response = await api.get<FilteredPolicemanResponse>("policemen", {
    params: {
      take,
      skip,
      relations: JSON.stringify(relations),
      order: JSON.stringify(order),
      where: JSON.stringify(where),
    },
  });
  return response.data;
}

export async function getPolicemanMapService(
  id: string
): Promise<IGetPolicemanMap> {
  const api = client();

  const getById = await api.get<IGetPolicemanResponse>(`policemen/one`, {
    params: { where: { id }, relations: { user: true } },
  });

  const workingStatus = await api.post("/occurrences/policemen/check", {
    policeman: id,
  });

  return new Promise((resolve, reject) => {
    Promise.allSettled([getById, workingStatus])
      .then((response) => {
        const getByIdResponse: PromiseSettledResult<AxiosResponse<any, any>> =
          response[0];
        const workingStatusResponse: PromiseSettledResult<
          AxiosResponse<any, any>
        > = response[1];

        resolve({
          policeman:
            getByIdResponse.status === "fulfilled"
              ? getByIdResponse.value.data.items
              : undefined,
          workStatus:
            workingStatusResponse.status === "fulfilled"
              ? workingStatusResponse.value.data.items
              : undefined,
        });
      })
      .then((error) => {
        reject(error);
      });
  });
}

export async function getPolicemanService(
  id: string
): Promise<IGetUniqueData<IGetByIdPoliceman>> {
  const api = client();
  console.log('PASSOU POR AQUI KKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKK', {
    params: {
      where: { id },
      relations: {
        policeman: true,
        vehicle: true,
        address: true,
        bankAccount: true,
        contact: true,
        role: true,
        // reports: true,
      },
    },
  })

  const response = await api.get<IGetUniqueData<IGetByIdPoliceman>>(
    `users/one`,
    {
      params: {
        where: { id },
        relations: {
          policeman: true,
          vehicle: true,
          address: true,
          bankAccount: true,
          contact: true,
          role: true,
          // reports: true,
        },
      },
    }
  );
  return response.data;
}

export async function getUpdatePolicemenService(): Promise<
  IFilterWithoutPageData<IUpdatePolicemen>
> {
  const api = client();
  const response = await api.get<IFilterWithoutPageData<IUpdatePolicemen>>(
    "policemen/updates"
  );
  return response.data;
}

export async function searchPolicemenService(
  query: string
): Promise<IFilterData<IPoliceman>> {
  const api = client();
  const response = await api.get<IFilterData<IPoliceman>>(
    `policemen?filter=${query}`
  );
  return response.data;
}

export async function activePolicemen(id: string) {
  const api = client();
  const response = await api.post(`policemen/${id}`);
  return response.data;
}

export async function deletePolicemen(id: string) {
  const api = client();
  const response = await api.delete(`policemen/${id}`);
  return response.data;
}

interface ApprovePolicemen {
  id: string;
  approve: boolean;
  paymentValues?: {
    patrimonialValues: IPolicemenValues;
    vehicleValues: IPolicemenValues;
  };
}

export async function approvePolicemen(data: ApprovePolicemen) {
  const api = client();
  await api.post(`policemen/approve/`, data);
  window.location.reload();
  return;
}

export async function confirmUpdatePolicemen(
  id: string,
  confirmation: boolean
) {
  const api = client();
  await api.post(`policemen/confirm`, {
    id,
    confirmation,
  });
  window.location.reload();
  return;
}

export async function createPolicemanService({
  policeman,
  contact,
  vehicle,
  address,
  banking,
  user,
  provider,
  pictures,
}: IPolicemanServiceProps) {
  const api = client();

  delete policeman.user;

  const formData = new FormData();

  formData.append(
    "body",
    JSON.stringify({
      user,
      contact,
      vehicle,
      provider,
      address: {
        ...address,
        complement: null,
      },
      policeman,
      bankingData: {
        accountData: { ...banking.accountData },
      },
      origin: "dashboard",
      type: "policeman",
    })
  );

  if (pictures) {
    Object.entries(pictures).forEach(([location, file]: [string, File]) => {
      formData.append(location, file);
    });
  }

  const response = await api.post("policemen", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return response.data;
}

export async function updatePolicemanService({
  policeman,
  contact,
  vehicle,
  address,
  baking,
  user,
  pictures,
}: IPolicemanUpdateServiceProps) {
  const api = client();

  const formData = new FormData();

  formData.append(
    "body",
    JSON.stringify({
      user,
      contact,
      vehicle,
      address: {
        ...address,
        complement: null,
      },
      policeman,
      bankingData: {
        id: baking.id,
        accountData: { ...baking.accountData },
      },
      origin: "dashboard",
    })
  );

  if (pictures) {
    Object.entries(pictures).forEach(([location, file]: [string, File]) => {
      formData.append(location, file);
    });
  }

  delete policeman.user;

  if (address.district === "") {
    delete address.district;
  }
  if (address.street === "") {
    delete address.street;
  }

  const response = await api.patch("policemen", formData);
  return response.data;
}
interface FilteredPolicemanResponse {
  all: number;
  actives: number;
  approved: number;
  data: IPoliceman[];
  status: boolean;
  total: number;
}
interface IUsePoliceman {
  page?: number;
  perPage?: number;
  filter?: string;
  working?: boolean;
  toApprove?: boolean;
  query: string;
}
